import React, { ReactNode } from 'react'

import styled from 'styled-components'

import backgroundImg from '@/assets/images/background.jpg'
import { useCustomSettings } from '@/core/hooks/misc/useCustomSettings'
import { useTranslation } from '@/core/i18n/useTranslation'
import { EnvironmentIndicator } from '@/shared/components/atoms/EnvironmentIndicator'
import { Link } from '@/shared/components/atoms/Link'
import { Logo } from '@/shared/components/atoms/Logo'

import { LanguageSelector } from './LanguageSelector'

interface AuthLayoutProps {
	children: ReactNode
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
	const { t } = useTranslation('common')
	const { data: customSettings } = useCustomSettings()
	const backgroundImage = customSettings?.images?.login_bg || backgroundImg

	return (
		<div className="flex justify-center items-center h-screen w-screen overflow-hidden relative bg-baseNeutral">
			<div className="flex w-full h-full">
				<div className="flex flex-1 overflow-auto flex-col p-6 bg-baseNeutral">
					<LogoContainer className="flex-center">
						<Link to="/">
							<Logo width="300px" height="auto" />
						</Link>
					</LogoContainer>

					<FormContainer>{children}</FormContainer>
				</div>

				<ImageSection $backgroundImage={backgroundImage}>
					<BrandMessage>
						<BrandHeading>{t('app.tagline')}</BrandHeading>
					</BrandMessage>
				</ImageSection>
			</div>

			{/* Language selector */}
			<LanguageSelector />

			{/* Show environment indicator */}
			<EnvironmentIndicator />
		</div>
	)
}

const LogoContainer = styled.div`
	padding: 1rem 0 3rem;
`

const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	flex: 1;
	max-width: 400px;
	margin: 0 auto;
	width: 100%;
`

const ImageSection = styled.div<{ $backgroundImage: string }>`
	flex: 2;
	background-image: url('${(props) => props.$backgroundImage}');
	background-size: cover;
	background-position: center;
	position: relative;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
	}
`

const BrandMessage = styled.div`
	position: absolute;
	bottom: 10%;
	left: 10%;
	color: white;
`

const BrandHeading = styled.h1`
	font-size: 3rem;
	font-weight: bold;
	margin: 0;
	line-height: 1.2;
`
